"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ['make', 'class', 'transmission'];
